import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';  // This imports the CSS file
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
import { API_CONFIG } from './config/api';

// ✅ FIX: Set global axios baseURL to point to backend
axios.defaults.baseURL = API_CONFIG.API_BASE;
console.log('✅ Axios baseURL configured:', axios.defaults.baseURL);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
